var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 133,
    viewBox: "0 0 114 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_20668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0587 92.3964C52.5042 92.3964 48.7849 88.6726 48.7849 84.0833C48.7849 79.4941 52.4911 75.7703 57.0587 75.7703C61.6132 75.7703 65.3325 79.4941 65.3325 84.0833C65.3325 88.6726 61.6262 92.3964 57.0587 92.3964ZM57.0587 77.3568C53.3655 77.3568 50.3509 80.3726 50.3509 84.0964C50.3509 87.8072 53.3525 90.8361 57.0587 90.8361C60.7519 90.8361 63.7664 87.8203 63.7664 84.0964C63.7664 80.3726 60.7649 77.3568 57.0587 77.3568Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1316 115.277H41.9858V105.967C41.9858 97.615 48.7458 90.8229 57.0587 90.8229C61.0782 90.8229 64.8627 92.4095 67.7076 95.281C70.5525 98.1395 72.1316 101.942 72.1316 105.967V115.277ZM43.5519 113.704H70.5525V105.967C70.5525 102.362 69.1431 98.9524 66.5853 96.3825C64.0405 93.8125 60.6475 92.3833 57.0457 92.3833C49.5941 92.3833 43.5388 98.4673 43.5388 105.954V113.704H43.5519Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.399 54.8303C20.8445 54.8303 17.1252 58.5541 17.1252 63.1302C17.1252 66.264 18.8609 69.0044 21.4187 70.4074C22.6063 71.0761 23.9505 71.4433 25.399 71.4433C26.8345 71.4433 28.1917 71.0761 29.3663 70.4205C31.9241 69.0175 33.6728 66.2771 33.6728 63.1302C33.6728 58.5541 29.9535 54.8303 25.399 54.8303ZM25.399 69.8698C21.7058 69.8698 18.6913 66.8541 18.6913 63.1302C18.6913 59.4195 21.7058 56.4037 25.399 56.4037C29.0922 56.4037 32.1068 59.4195 32.1068 63.1302C32.1068 66.8541 29.0922 69.8698 25.399 69.8698Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4389 68.5455C49.2677 70.1583 46.1226 71.7449 42.9776 73.3314L37.1181 76.2816V103.043H22.6585C20.1268 103.043 17.5951 103.03 15.0764 103.017L10.4958 103.004L10.3262 85.0143C10.3262 78.0387 15.0373 72.1644 21.4188 70.4074C22.6063 71.0761 23.9505 71.4433 25.3991 71.4433C17.9474 71.4433 11.8922 77.5273 11.8922 85.0143L12.0488 101.431L15.0764 101.444C16.0421 101.444 17.0078 101.457 17.9735 101.457V102.322H19.5396V101.457C20.5836 101.47 21.6145 101.47 22.6585 101.47H35.5521V75.3114L35.9827 75.0884L42.2729 71.9153C45.4179 70.3288 48.563 68.7553 51.7081 67.1556C53.3394 66.2509 53.9658 64.5725 53.6004 63.5498C53.3916 62.9598 52.8043 62.4484 52.0213 62.1599C50.9512 61.7666 49.7245 61.8977 48.6674 62.5139L30.1493 72.0464L29.8491 72.2169L29.549 72.0989C28.244 71.6662 26.8346 71.4433 25.3991 71.4433C26.8346 71.4433 28.1918 71.0761 29.3663 70.4205C29.4837 70.4337 29.5881 70.4599 29.6925 70.5123L47.9105 61.1241C48.5761 60.7307 49.3199 60.4947 50.0638 60.416C50.9251 61.2421 52.6477 62.5664 55.0881 63.0384C55.7406 64.9528 54.5791 67.3523 52.4389 68.5455Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3991 71.4433C23.9505 71.4433 22.6063 71.0761 21.4188 70.4074C15.0373 72.1644 10.3262 78.0387 10.3262 85.0143L10.4958 103.004L15.0764 103.017C17.5951 103.03 20.1268 103.043 22.6585 103.043H37.1181V76.2816L42.9776 73.3314C46.1226 71.7449 49.2677 70.1583 52.4389 68.5455C54.5791 67.3523 55.7406 64.9528 55.0881 63.0384C52.6477 62.5664 50.9251 61.2421 50.0638 60.416C49.3199 60.4947 48.5761 60.7307 47.9105 61.1241L29.6925 70.5123C29.5881 70.4599 29.4837 70.4337 29.3663 70.4205C28.1918 71.0761 26.8346 71.4433 25.3991 71.4433ZM25.3991 71.4433C17.9474 71.4433 11.8922 77.5273 11.8922 85.0143L12.0488 101.431L15.0764 101.444C16.0421 101.444 17.0078 101.457 17.9735 101.457V102.322H19.5396V101.457C20.5836 101.47 21.6145 101.47 22.6585 101.47H35.5521V75.3114L35.9827 75.0884L42.2729 71.9153C45.4179 70.3288 48.563 68.7553 51.7081 67.1556C53.3394 66.2509 53.9658 64.5725 53.6004 63.5498C53.3916 62.9598 52.8043 62.4484 52.0213 62.1599C50.9512 61.7666 49.7245 61.8977 48.6674 62.5139L30.1493 72.0464L29.8491 72.2169L29.549 72.0989C28.244 71.6662 26.8346 71.4433 25.3991 71.4433Z",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5396 101.457H17.9736V102.322H19.5396V101.457Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3662 70.4205C28.1917 71.0761 26.8345 71.4433 25.399 71.4433C23.9504 71.4433 22.6063 71.0761 21.4187 70.4074C22.6846 70.0534 24.0157 69.8698 25.399 69.8698C26.7562 69.8698 28.1004 70.0534 29.3662 70.4205Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8037 34.454C68.4905 33.2346 67.1203 29.0519 62.9181 26.7572C58.3114 24.2528 52.2431 25.092 48.4716 28.7634C45.0395 32.1201 44.909 36.5913 45.0134 38.3614C45.3005 43.1342 48.1584 46.2156 49.3982 47.3432V59.721L49.607 59.9439C49.7114 60.062 49.868 60.2193 50.0638 60.416C50.9251 61.242 52.6477 62.5664 55.0881 63.0384C55.6753 63.1695 56.3017 63.2351 56.9803 63.2351H57.2413C57.8416 63.222 58.3897 63.1564 58.9117 63.0515H58.9248C61.2216 62.5795 62.892 61.3601 63.8969 60.416C64.4319 59.8915 64.7843 59.4588 64.9278 59.2621L65.0975 59.0523V47.3039C66.1937 46.1369 70.5002 40.997 68.8037 34.454ZM63.7664 46.4254L63.5315 46.6483V58.5147C62.8529 59.3277 60.6866 61.5698 57.2022 61.6616C53.9396 61.7403 51.7081 59.8522 50.9642 59.1048V46.6221L50.6902 46.386C49.7897 45.6255 46.8534 42.8196 46.5794 38.2697C46.488 36.7093 46.5924 32.7888 49.5679 29.891C52.8565 26.6917 58.1548 25.9443 62.1612 28.134C65.8283 30.1402 67.0159 33.7853 67.2899 34.8605C68.9603 41.2723 63.8186 46.3729 63.7664 46.4254Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3014 51.9456H50.1812V53.519H64.3014V51.9456Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3014 56.3381H50.1812V57.9116H64.3014V56.3381Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8807 40.4069H56.3147V52.7323H57.8807V40.4069Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1239 41.4821L52.7651 37.8763L53.7569 36.6569L57.1108 39.4366L60.3473 36.67L61.3652 37.8632L57.1239 41.4821Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5585 38.6761H33.0073V40.2496H39.5585V38.6761Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5456 38.6761H28.8442V40.2496H31.5456V38.6761Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0664 17.2028L36.9055 18.2589L43.8691 25.9863L45.03 24.9302L38.0664 17.2028Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0243 10H56.4583V17.0019H58.0243V10Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0243 18.8769H56.4583V20.8568H58.0243V18.8769Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5365 17.072L68.9451 24.9083L70.0673 26.0058L77.6587 18.1694L76.5365 17.072Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4624 38.6761H74.8069V40.2496H81.4624V38.6761Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.273 38.6761H83.3416V40.2496H85.273V38.6761Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5396 89.5248H17.9736V102.322H19.5396V89.5248Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.088 63.0384C52.6476 62.5664 50.925 61.242 50.0637 60.416C50.912 60.298 51.7602 60.3898 52.5693 60.6782C53.783 61.124 54.6965 61.9763 55.075 63.0122C55.075 63.0253 55.075 63.0253 55.088 63.0384Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6007 54.8303C84.0462 54.8303 80.3269 58.5541 80.3269 63.1302C80.3269 66.2771 82.0756 69.0175 84.6334 70.4205C85.821 71.0761 87.1652 71.4433 88.6007 71.4433C90.0362 71.4433 91.3934 71.0761 92.581 70.4205C95.1388 69.0044 96.8745 66.264 96.8745 63.1302C96.8745 58.5541 93.1552 54.8303 88.6007 54.8303ZM88.6007 69.8698C84.9075 69.8698 81.8929 66.8541 81.8929 63.1302C81.8929 59.4195 84.9075 56.4037 88.6007 56.4037C92.2939 56.4037 95.3084 59.4195 95.3084 63.1302C95.3084 66.8541 92.2939 69.8698 88.6007 69.8698Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5811 70.4205C91.3935 71.0761 90.0363 71.4433 88.6008 71.4433C87.1653 71.4433 85.8211 71.0761 84.6335 70.4205C85.8994 70.0534 87.2436 69.8698 88.6008 69.8698C89.9841 69.8698 91.3152 70.0534 92.5811 70.4205Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0262 101.457H94.4602V102.322H96.0262V101.457Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0262 89.5248H94.4602V102.322H96.0262V89.5248Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.674 85.0142L103.504 103.004L98.9234 103.017C96.4048 103.03 93.873 103.043 91.3413 103.043L76.8818 103.109V76.2816L71.0353 73.3314C67.8902 71.7448 64.7321 70.1582 61.587 68.5586C59.4207 67.3522 58.2593 64.9527 58.9118 63.0515H58.9248C61.2216 62.5794 62.8921 61.36 63.8969 60.416C64.6669 60.4946 65.4107 60.7438 66.1154 61.1502L84.3073 70.5123C84.4117 70.4598 84.5161 70.4336 84.6335 70.4205C85.8211 71.0761 87.1653 71.4432 88.6008 71.4432C87.1653 71.4432 85.7559 71.6661 84.4508 72.0988L84.1376 72.2168L83.8505 72.0464L65.3716 62.527C64.2754 61.8976 63.0487 61.7665 61.9785 62.1599C61.1955 62.4483 60.6083 62.9597 60.3995 63.5497C60.0341 64.5856 60.6605 66.2508 62.3178 67.1687C65.4368 68.7552 68.595 70.3418 71.74 71.9284L78.0171 75.0884L78.4478 75.3506V101.535L91.3413 101.47C92.3853 101.47 93.4163 101.47 94.4603 101.457V102.322H96.0263V101.457C96.992 101.457 97.9577 101.444 98.9234 101.444L101.951 101.431L102.108 85.0011C102.108 77.5272 96.0524 71.4432 88.6008 71.4432C90.0363 71.4432 91.3935 71.0761 92.5811 70.4205C98.9756 72.1644 103.674 78.0517 103.674 85.0142Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6008 71.4432C87.1653 71.4432 85.8211 71.0761 84.6335 70.4205C84.5161 70.4336 84.4117 70.4598 84.3073 70.5123L66.1154 61.1502C65.4107 60.7438 64.6669 60.4946 63.8969 60.416C62.8921 61.36 61.2216 62.5794 58.9248 63.0515H58.9118C58.2593 64.9527 59.4207 67.3522 61.587 68.5586C64.7321 70.1582 67.8902 71.7448 71.0353 73.3314L76.8818 76.2816V103.109L91.3413 103.043C93.873 103.043 96.4048 103.03 98.9234 103.017L103.504 103.004L103.674 85.0142C103.674 78.0517 98.9756 72.1644 92.5811 70.4205C91.3935 71.0761 90.0363 71.4432 88.6008 71.4432ZM88.6008 71.4432C87.1653 71.4432 85.7559 71.6661 84.4508 72.0988L84.1376 72.2168L83.8505 72.0464L65.3716 62.527C64.2754 61.8976 63.0487 61.7665 61.9785 62.1599C61.1955 62.4483 60.6083 62.9597 60.3995 63.5497C60.0341 64.5856 60.6605 66.2508 62.3178 67.1687C65.4368 68.7552 68.595 70.3418 71.74 71.9284L78.0171 75.0884L78.4478 75.3506V101.535L91.3413 101.47C92.3853 101.47 93.4163 101.47 94.4603 101.457V102.322H96.0263V101.457C96.992 101.457 97.9577 101.444 98.9234 101.444L101.951 101.431L102.108 85.0011C102.108 77.5272 96.0524 71.4432 88.6008 71.4432Z",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8969 60.416C62.892 61.3601 61.2216 62.5795 58.9248 63.0515C58.9248 63.0384 58.9248 63.0384 58.9248 63.0253C59.2902 61.9763 60.2168 61.124 61.4304 60.6782C62.2265 60.3898 63.0617 60.298 63.8969 60.416Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6777 120.771H36.4524V122.344H77.6777V120.771Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8 120.771H81.1101V122.344H86.8V120.771Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6418 120.771H26.9519V122.344H32.6418V120.771Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.321 42.9681C29.0787 48.2998 23.0396 57.4511 22.7026 67.3063C22.3657 77.1616 28.4048 87.2514 37.6838 90.4062C42.5437 92.0617 47.8182 91.814 52.9502 91.5403C59.8706 91.1753 66.8039 90.8233 73.7243 90.4583C75.9922 90.341 78.3379 90.1976 80.3466 89.1156C84.9602 86.6127 85.8026 80.4336 86.0618 75.1671C86.4765 66.7849 86.7486 58.0899 83.6124 50.3074C81.2019 44.3108 76.2384 38.8617 69.9401 37.0237C66.8946 36.1372 63.577 36.411 60.4408 36.4501C56.6307 36.5022 52.8206 36.9715 49.1271 37.9101C44.9801 38.953 40.9496 40.6216 37.321 42.9681Z",
    fill: "#18499A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_20668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.3475,
    height: 112.344,
    fill: "white",
    transform: "translate(10.3262 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.bebbb6b25ba6421598a3e6288e1587b4.svg";
export { ForwardRef as ReactComponent };